<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="goback"></div>
      </div>
      <div class="header">{{this.comeType == '11'?'居民议事厅':'党委联席会议'}}</div>
      <div class="newvote">
        <Button class="bkcc-btn" @click="submit">发布</Button>
      </div>
    </div>
    <div class="content">
      <Card>
        <div class="card-con topc">
          <Form :label-width="80">
            <FormItem label="封面图">
              <upload-img
                :imgArr="imgArr"
                :imgNumber="imgNumber"
                :fixedNumber="fixedNumber"
                :imgHeight="150"
                :imgWidth="240"
                @saveImg="saveImg"
                @delPic="delPic"
                :isActive="isActive"
              >
                <div class="uploadbox">
                  <i class="iconfont icon-shangchuan1"></i>
                  <p class="fengmian">请上传封面</p>
                  <p class="tips">注意图片尺寸为：8:5</p>
                </div>
              </upload-img>
            </FormItem>
            <FormItem label="议题">
              <Input placeholder="请输入议题" v-model="title" class="kuang" />
            </FormItem>
            <FormItem label="详情">
              <Input placeholder="请输入详情" v-model="context" type="textarea" class="kuang" />
            </FormItem>
            <FormItem label="开始时间">
              <div class="kuang box" style="justify-content:space-between">
                <div style="width:48.5%">
                  <DatePicker type="date" placeholder="请选择日期" v-model="date" style="width: 100%"></DatePicker>
                </div>
                <div style="width:48.5%">
                  <TimePicker
                    type="time"
                    placeholder="请选择时间"
                    v-model="time"
                    format="HH:mm"
                    style="width: 100%;"
                  ></TimePicker>
                </div>
              </div>
            </FormItem>
            <FormItem label="地点">
              <div v-if="didian" class="address"  @click="showmap()">{{didian}}</div>
              <div v-else @click="showmap()" class="address address_nodata">请选择地点</div>
              <map-modal v-if="showMap"
                  @confirm="getAddress"
                  @cancel="showmap"
                  :zuobiao="zuobiao"></map-modal>
            </FormItem>
            <FormItem label="参会人" >
              <div class="choosePeople box">
                <div v-for="(item,index) in peopleList" :key="item.id" class="box item_people" @click="deletePeople(index)">
                  <div>{{ item.name}}</div>
                  <div class="quxiao">×</div>
                </div>
                <Button  @click="clickModal" type="primary">选择参会人</Button>
              </div>
              <!-- modal 区域 -->
              <select-people
              v-if="showAdd"
              :peopleList="peopleList"
              labelWidth="60px"
              @modalCancel = "clickModal"
              @modalSelect = "modalSelect"
              ></select-people>
            </FormItem>
            <FormItem label="短信通知">
              <RadioGroup v-model="send">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="发布至">
              <Select v-model="selList" multiple @on-change="syncChange" :placeholder="'请选择'+(comeType == '11'?'微社区':'微支部')+'，默认发布至全部'" class="kuang">
                <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="是否置顶">
              <RadioGroup v-model="isTop">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </FormItem>
          </Form>
        </div>
      </Card>
      <Card style="margin-top: 20px">
        <div class="card-con" style="margin-top: 20px;">
          <Form :label-width="80">
            <FormItem label="议事结果">
              <!-- <Input placeholder="议事结果（选填）" v-model="result" style="width: 875px" /> -->
               <editor-box
                  :content="result"
                  height="400px"
                  style="width: 875px;display: inline-block;"
                  @editorContent="resultContent"
                ></editor-box>
            </FormItem>
            <FormItem label="附件">
              <div class="demo-upload-list" v-for="(item, index) in uploadList" :key="index">
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" />
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                multiple
                type="drag"
                :action="upLink"
                :headers="upHead"
                style="display: inline-block;width:58px;"
              >
                <div style="width: 58px;height:58px;line-height: 1.5;">
                  <div class="iconfont icon-shangchuan1" style="font-size:26px"></div>
                  <i>上传图片</i>
                </div>
              </Upload>
              <Modal title="图片预览" v-model="visible">
                <img :src="imgName" v-if="visible" style="width: 100%" />
              </Modal>
            </FormItem>
            <FormItem>
              <div class="demo-upload-list" v-for="(item, index) in uploadList1" :key="index">
                <template v-if="item.status === 'finished'">
                  <video :src="item.url" :id="index"></video>
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView1(item)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove1(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
              </div>
              <Upload
                ref="upload1"
                :show-upload-list="false"
                :default-file-list="defaultList1"
                :on-success="handleSuccess1"
                :on-format-error="handleFormatError1"
                :format="['mov','avi','3gp','mp4','flv']"
                multiple
                type="drag"
                :action="upLink"
                :headers="upHead"
                style="display: inline-block;width:58px;"
              >
                <div style="width: 58px;height:58px;line-height: 1.5;">
                  <div class="iconfont icon-shangchuan1" style="font-size:26px"></div>
                  <i>上传视频</i>
                </div>
              </Upload>
              <Modal title="视频播放" v-model="visible1" @on-ok="modalOk" @on-cancel="modalCancel">
                <video-player
                  class="vjs-custom-skin"
                  ref="videoPlayer"
                  :options="options"
                  :playsinline="true"
                ></video-player>
              </Modal>
              <Modal
                  v-model="noresult"
                  title="提示"
                  @on-ok="ok"
                  @on-cancel="cancel">
                  <div style="font-size:16px">没有填写议事结果，会议只有参会人可见</div>
              </Modal>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
    <Spin fix v-if="loading"></Spin>
  </div>
</template>

<script>
import editorBox from "../../../components/editorBox";
import uploadImg from "../../../components/uploadImg";
import selectPeople from "../components/selectPeople";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import mapModal from '../../../components/mapModal';
var vm;

export default {
  components: {
    editorBox,
    uploadImg,
    videoPlayer,
    selectPeople,
    mapModal
  },
  data() {
    return {
       comeType:this.$route.query.comeType,
      imgNumber: 1,
      imgArr: [],
      fixedNumber: [8, 5],
      isActive: false,
      title: "",
      context: "",
      date: "",
      time: "",
      didian: "",
      center: [116.66517, 39.90575],
      showMap: false,
      zuobiao: {},
      selZhuan: [],
      qyList: [],
      workerList: [],
      jmList: [],
      send: 1,
      isTop: 1,
      zoneList: [],
      selList: [],
      result: "",
      imgName: "",
      visible: false,
      uploadList: [],
      defaultList: [],
      upLink: "",
      upHead: {},
      imgName1: "",
      visible1: false,
      uploadList1: [],
      defaultList1: [],
      options: {
        //属性
        muted: false,
        autoplay: false, //自动播放
        width: "490", //宽度
        sources: [
          {
            //视频内容
            src: ""
          }
        ]
      },
      loading: false,
      showAdd:false,
      peopleList:[],//以选择的参会人
      noresult:false,//是否没有议事结果
    };
  },
  methods: {
    resultContent(data) {
      // 接收富文本中的内容
      this.result = data;
    },
    goback() {
      this.$router.go(-1);
    },
    saveImg(data) {
      this.imgArr.splice(0, 1, data);
      this.isActive = true;
    },
    delPic() {
      this.imgArr = [];
    },
    showmap() {
      this.showMap = !this.showMap;
    },
    getAddress(val){
      this.zuobiao = val
      console.log('-------assemblyNew----------')
      console.log(this.zuobiao)
      this.didian = val.label
      this.coordinate = val.value
      this.showmap()
    },
    getZhuanList() {
      var getCompany = this.getPeople("company");
      var getResident = this.getPeople("resident");
      var getWorker = this.getPeople("worker");
      Promise.all([getCompany, getWorker, getResident]).then(res => {
        this.qyList = res[0].rows;
        (this.workerList = res[1].rows), (this.jmList = res[2].rows);
      });
    },
    getPeople(type) {
      var url = this.urlobj.getPerson;
      var data = {
        pageNum: 0,
        pageSize: 0,
        queryType: type
      };
      return new Promise((resolve, reject) => {
        this.$get(url, data)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getXiaoqu() {
      var url = this.urlobj.getOrg();
      var data = {
        communityId: this.$store.state.streetorcommunityid,
        zoneType: 1 // 表示微社区和微支部
      };
      this.$get(url, data).then(res => {
        var list = [];
        var zoneList = res.rows.map(item => {
          return {
            name: item.zoneName,
            id: item.zoneId
          };
        });
        this.zoneList = [...list, ...zoneList];
      });
    },
    syncChange(val) {
      console.log(this.selList);
    },
    handleView(item) {
      this.imgName = item.url;
      this.visible = true;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      console.log(res);
      console.log(file);
      file.name = res.rows[0].filename;
      file.url = res.rows[0].filepath;
      this.$refs.upload.fileList;
      console.log(this.$refs.upload.fileList)
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "图片类型错误",
        desc: "图片 " + file.name + " 类型错误，请选择 jpg 或 png图片"
      });
    },
    handleFormatError1(file) {
      this.$Notice.warning({
        title: "视频类型错误",
        desc:
          "视频 " + file.name + " 类型错误，请选择 mov、3gp、mp4、flv、mov视频"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片大小超过限制",
        desc: "图片" + file.name + " 过大, 图片大小应小于2M."
      });
    },
    handleView1(item) {
      this.options.sources[0].src = item.url;
      this.visible1 = true;
    },
    handleRemove1(file) {
      const fileList = this.$refs.upload1.fileList;
      this.$refs.upload1.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess1(res, file) {
      console.log(res);
      console.log(file);
      file.name = res.rows[0].filename;
      file.url = res.rows[0].filepath;
      this.$refs.upload1.fileList;
    },
    modalOk() {
      //点击确定按钮暂停视频，关闭对话框
      this.visible1 = false;
      this.$refs.videoPlayer.player.pause();
    },
    modalCancel() {
      //点击取消按钮暂停视频，关闭对话框
      this.visible1 = false;
      this.$refs.videoPlayer.player.pause();
    },
    ok(){
      this.noresult=false
      let qyList = [];
      let userList = [];
      let cList = [];
      let uId = [];
      let data = {
        id: this.$route.query.id ? this.$route.query.id : '',
        title: this.title,
        content: this.context,
        address: this.didian,
        coordinate: "",
        comeType: this.comeType,
        isSendMsg: this.send,
        zoneList: this.selList.length == 0 ? [{zoneId: -1}] : this.selList.map(item => {
          return {
            zoneId: item
          }
        }),
        isTop: this.isTop,
        resultContent: this.result,
        join:{}
      };
      //处理会议时间
      var date = this.$util.FormatDate(this.date, "yyyy-MM-dd");
      date = date + ' ' + this.time + ':00'
      data.beginTime = date
      //处理选择的地点
      if (this.coordinate) {
        var zuobiao = this.coordinate.split(",");
        var a = {
          x: zuobiao[0],
          y: zuobiao[1]
        };
        data.coordinate = '{"x":"' + zuobiao[0] + '","y":"' + zuobiao[1] + '"}';
      }
      //处理参会人unionId
      ////////////////////////////////
      console.log('----处理参会人unionId---peopleList-------submit----')
      console.log(this.peopleList)
      let peopleobj = {
        company:[],
        worker:[],
        resident:[]
      }
      this.peopleList.forEach(item => {
        //判断类型
        if(item.type=="company"){
            let _tmp = {
              id:item.id,
              userList:item.userList.map(_item => {
                return {
                  unionId: _item.unionId
                }
              })
            }
            peopleobj.company.push(_tmp)
        }else{
          peopleobj[item.type].push({unionId:item.unionId})
        }
      })
      data.join = peopleobj

      ///////////////////////////
      let piclist = this.uploadList.map(item => {
        return {
          isResult: 1,
          attachmentUrl: item.url,
          coverUrl: "",
          timeLength: ""
        };
      });
      let vlist = this.uploadList1.map(item => {
        return {
          isResult: 1,
          attachmentUrl: item.url,
          coverUrl: "",
          timeLength: parseInt(item.time * 100)
        };
      });
      let fengmian = [{
        isResult: 0,
        attachmentUrl: this.imgArr[0].path,
        coverUrl: "",
        timeLength: ""
      }];
      var attachmentList = [...fengmian, ...piclist, ...vlist]
      data.attachmentList = attachmentList
      console.log(data)
      this.loading = true
      this.$post(this.urlobj.assembly, data).then(res => {
        this.loading = false
        this.$Message.success('发布成功')
        this.$router.push({path: `/Shequ/assembly/?comeType=${this.comeType}`})
      }).catch(e => {
        this.loading = false
      })
    },
    cancel(){},
    submit() {
      //验证必填项
      if(this.imgArr.length == 0) {
        this.$Message.warning('请上传封面')
        return
      }
      if(this.title == '') {
        this.$Message.warning('请填写议题')
        return
      }
      if(this.date == '' || this.time == '') {
        this.$Message.warning('请选择开始日期和时间')
        return
      }
      if(this.didian == '') {
        this.$Message.warning('请选择会议地址')
        return
      }
      if(this.peopleList.length == 0) {
        this.$Message.warning('请选择参会人')
        return
      }
      //获取附件视频时长
      for (let i = 0; i < this.uploadList1.length; i++) {
        this.uploadList1[i].time = document.getElementById(i).duration;
      }
      if(!this.result){
        this.noresult=true
      }else{
        this.ok()
      }
    },
    getDetail(id) {
      //编辑用
      var that = this
      let url = this.urlobj.assDetail(id);
      this.loading = true
      this.$get(url).then(res => {
        var fengmian = []
        var picList = []
        var videoList = []
        let resData = res.rows[0]
        //其他数据
        this.title = resData.title
        this.context = resData.content
        this.send = resData.isSendMsg
        this.isTop = resData.isTop
        this.result = resData.resultContent
        //处理返回的附件列表
        resData.attachmentList.forEach(item => {
          if(item.isResult == 0) {
            fengmian.push(item)
          }else {
            if(!item.timeLength){
              picList.push(item)
            }else {
              videoList.push(item)
            }
          }
        })
        this.imgArr = [{path: fengmian[0].attachmentUrl}]
        this.$refs.upload.fileList = picList.map(item => {
          return {
            url: item.attachmentUrl,
            status: 'finished'
          }
        })
        this.$refs.upload1.fileList = videoList.map(item => {
          return {
            url: item.attachmentUrl,
            duration: item.timeLength,
            status: 'finished'
          }
        })
        this.uploadList = this.$refs.upload.fileList;
        this.uploadList1 = this.$refs.upload1.fileList;
        //处理时间
        var beginTime = resData.beginTime
            .substr(0, resData.beginTime.length - 2)
            .split(" ");
        this.date = new Date(beginTime[0])
        this.time = beginTime[1]
        //处理地址
        if (resData.coordinate) {
          var reg = /[0-9]+.[0-9]+/g;
          var xy = resData.coordinate.match(reg);
          // console.log(data.coordinate)
          that.zuobiao.value = xy.join(",");
          that.zuobiao.label = resData.address;
          that.coordinate = xy.join(",");
        }
         console.log(that.zuobiao)
        console.log(this.zuobiao)
        this.didian = resData.address
        //this.didian = resData.address.substr(0, resData.address.length - 1)

        // var list = []
        // list = resData.userList.map(item => {
        //   return item.unionId
        // })
        // this.selZhuan = list
        // console.log(this.selZhuan, list)

        //处理参会人
        let join = [];
          Object.keys(resData.join).forEach(key=>{
            resData.join[key].forEach(item=>{
                if(key=='company'){
                    join.push({
                      type:key,
                      id:item.id,
                      select:true, // 是否被选中 id是否出现在被选中的列表里,
                      userName:item.name,
                      name:item.name,
                      userList:item.userList,
                      headPicUrl:item.headPicUrl,
                    })
                }else{
                    join.push({
                      type:key,
                      id:item.uId,
                      unionId:item.unionId,
                      select:true, // 是否被选中 id是否出现在被选中的列表里,
                      userName:item.userName,
                      realName:item.realName?item.realName:'暂无姓名',
                      name:(item.realName?item.realName:'暂无姓名')+'('+item.userName+')',
                      headPicUrl:item.headPicUrl,
                    })
                }
            })

          })
          console.log('===============')
          console.log(join)
          this.peopleList = join
        //发布至
        this.selList = resData.zoneList.length == this.zoneList.length ? [] : resData.zoneList.map(item => {
          return item.zoneId
        })

        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
    //打开或者关闭选择参会人
    clickModal(){
        this.showAdd = !this.showAdd
    },
    modalSelect(data){
      console.log('data')
      console.log(data)
      this.peopleList = data

    },
    /**删除参会人 */
    deletePeople(idx){
      this.peopleList.splice(idx,1)
      console.log(this.peopleList)
    }
  },
  mounted() {
    //this.getZhuanList();
    this.getXiaoqu();
    //如果点击编辑进入 先获取草稿
    if(this.$route.query.id) {
      this.getDetail(this.$route.query.id)
    }
    this.uploadList = this.$refs.upload.fileList;
    this.uploadList1 = this.$refs.upload1.fileList;

  },
  created() {
    vm = this;
    this.upLink = this.urlobj.uploadFile;
    this.upHead = {
      "X-Requested-With": "XMLHttpRequest",
      token: this.$store.state.access_token || ""
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.header {
  font-size: 25px;
  text-align: center;
}
.newvote {
  position: absolute;
  right: 20px;
}
.content {
  // max-width: 96%;
  margin: 20px;
}
.add-con {
  font-size: 16px;
  color: #999;
  width: 110px;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
}
.uploadbox {
  width: 238px;
  height: 148px;
  border: 1px dashed #ddd;
  text-align: center;
  margin-top: 12px;
  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
    color: #e3e3e3;
    margin-top: 32px;
  }
  .fengmian {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
  }
  .tips {
    font-size: 14px;
    color: #999;
  }
}
/deep/ .ivu-form-item-label {
  font-size: 16px;
  color: #333;
  //   margin-top: -3px;
}
.card-con {
  width: 945px;
  margin: 0 auto;
}
.active-amap {
  width: 100%;
  height: 300px;
  position: absolute;
  top: 40px;
  z-index: 999;
}
.topc {
  /deep/ .ivu-tag {
    background-color: #fff;
    border: 1px solid #ff7b44;
  }
  /deep/ .ivu-icon-ios-close {
    color: #ff7b44;
    transform: scale(1) !important;
    opacity: 1 !important;
  }
  /deep/ .ivu-tag-text {
    color: #ff7b44;
  }
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.choosePeople{
  color:#ff7b44;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  .item_people{
    border:1px solid #ff7b44;
    border-radius: 4px;
    margin-right: 10px;
    height: 29px;
    line-height: 29px;
    padding: 0 9px;
    margin-top: 5px;
  }
  .quxiao{
    margin-left:6px;
    font-size: 10px
  }
   .ivu-btn {
    font-size: 16px;
    line-height: 1;
    margin-top: 5px;
  }
  /deep/ .ivu-btn-primary{
    background-color: #ff7b44;
    border-color:#ff7b44
  }
}

.kuang{
  width:100%;
  max-width: 875px;
}
/*选择地点的样式*/
.address{
    width: 100%;
    height: 32px;
    line-height: 24px;
    padding: 4px 7px;
    font-size: 12px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: text;

}
.address_nodata{
  color:#bbb
}
.address:hover{
  border: 1px solid #ff7b44;
}
.address:active{
  border: 1px solid #ff7b44;
}

</style>
